import { useConsultation } from '@entities/consultations';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';

import Name from './frames/Name';
import Portrait from './frames/Portrait';
import StartDate from './frames/StartDate';
import Status from './frames/Status';
import Tags from './frames/Tags';
import Time from './frames/Time';
import Type from './frames/Type';

import * as st from './styles.module.scss';

export const ConsultationCard = ({ id }) => {
	const { consultation } = useConsultation(id);
	const navigate = useNavigate();

	const getStatus = (consultation) => {
		let status = '';
		if (consultation.cancelled) {
			status = 'cancelled';
		}

		if (!consultation.paid.paid && consultation.paid.transaction) {
			status = 'payment-unconfirmed';
		}

		if (!consultation.paid.paid && !consultation.paid.transaction) {
			status = 'not-payed';
		}

		if (!consultation.confirmed) {
			status = 'moving';
		}
		return status;
	};

	const getStyle = (status) => {
		switch (status) {
			case 'cancelled':
				return st.red;
			case 'payment-unconfirmed':
				return st.yellow;
			case 'not-payed':
				return st.red;
			case 'moving':
				return st.yellow;
			default:
				break;
		}
	};

	return (
		<div className={cn(st.card, getStyle(getStatus(consultation)))}>
			<section
				className={st.card__portrait}
				onClick={() => navigate(`consultation/${consultation.id}`)}
			>
				<Portrait image={consultation.coach.photo} />
			</section>
			<section
				className={st.card__info}
				onClick={() => navigate(`consultation/${consultation.id}`)}
			>
				<div className={st.card__coach}>
					<Name coach={consultation.coach} />
					<Tags coach={consultation.coach} />
				</div>
				<div className={st.card__time}>
					<Type type={consultation.type} />
					<StartDate date={consultation.start_time} />
					<Time date={consultation.start_time} />
				</div>
			</section>
			<section className={st.card__menu}>
				{/* <Menu consultation={consultation} /> */}
				<Status status={getStatus(consultation)} />
			</section>
		</div>
	);
};
